import apiUrl from '../../../constants';
import axios from 'axios';
import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
export default {
    name: 'merchant',
    components: {Paginate,VueElementLoading},
    data: function() {
        return {
            //modalShow used for close the active/inactive modal(default)
            merchantorsupplier: '',
            modalShow: false,
            updatemerchantmodal: false,
            editmerchantmodal: false,
            addmerchantmodal: false,
            merchantaction: '',
            listClientData: [],
            listStateData: [],
            listCityData: [],
            merchantpersonemail: '',
            businesstype: '',
            pageno: 0,
            pagecount: 0,
            merchantname: '',
            merchantid: '',
            status: '',
            localwarehouseid: '',
            localclientid: '',
            isLoading: false,
            resultCount:'',
            model: {
                name: '',
                username: ''
            },
            // initialize form field
            addmerchant: {
                merchantname: '',
                businesstype: '',
                merchantpersonemail: '',
                merchantaddress: '',
                merchantaddress2: '',
                country: '',
                state: '',
                city: '',
                pincode: '',
                merchantpersonname: '',
                merchantpersonmobile: '',
                merchantpersonphone: '',
                merchantregisternum: '',
                merchantpanid: '',
                merchantgstnum: '',
                merchantloginemail: '',
                password: '',
                suppliergstnno: '',
                druglicenseno: '',
                foodlicenseno: '',
                contactdetails: '',
                pannumber: '',
                druglicensenodate: ''
            },
            status: '',
            changestatus: '',
            loginuserid: '',
        }
    },
    created: function() {
        // when a page loads,mounted() will be call
    },
    mounted() {
        var permissionEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdbyEmail = userdetail.email;
        this.localwarehouseid = userdetail.warehouseid;
        this.localclientid = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        this.pageno = 0;
        this.getMerchantData();
        this.getStateList();
    },
    methods: {
        //open new form(popup)
        addNewMerchant() {
            //to initialize all form field or used for clear the form
            this.addmerchant = [],
                this.merchantaction = 'add',
                this.addmerchantmodal = true;
            //to clear error messages(validation messages)
            this.$validator.reset();
            this.errors.clear();
        },
        addmodalShow() {
            this.Statusaction = 'add'
            this.addmodalShow = true
        },
        //to close active/inactive modal
        closeaddmodalShow() {
            this.addmodalShow = false
        },
        closeStatusMerchantModal() {
            this.modalShow = false
        },
        //to close new form
        closeAddMerchantModal() {
            this.addmerchantmodal = false
        },
        //to close edit form
        closeEditMerchantModal() {
            this.addmerchantmodal = false
        },
        //to reset search form
        resetForm() {
            this.merchantname = '';
            this.merchantpersonemail = '';
            this.businesstype = '';
            this.getMerchantData();
        },
        //for active/inactive modal
        changeMerchantStatus() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateMerchantStatus',
                    'data': {
                        'merchantid': this.merchantid,
                        'status': this.status.trim(),
                    },
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.msg > 0) {
                        this.$alertify.success("Merchant Status update Successfully")
                        this.addmerchantmodal = false
                        this.getMerchantData();
                    }
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },

        //to get state list
        getStateList() {
            this.input = ({})
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'stateList',
                    'data': this.input
                })
                .then(result => {
                    this.listStateData = result.data
                }, error => {
                    console.error(error)
                })
        },
        //depending on state ,get city list
        getCityList() {
            this.input = ({
                "statename": this.addmerchant.merchantstate
            })
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'cityList',
                    'data': this.input
                })
                .then(result => {
                    this.listCityData = result.data
                }, error => {
                    console.error(error)
                })
        },
        //to get merchant list
        getMerchantData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                offset: this.pageno,
                limit: 10,
                merchantname: this.merchantname.trim(),
                merchantpersonemail: this.merchantpersonemail.trim(),
                businesstype: this.businesstype.trim(),
                clientid: this.localclientid,
                userid: this.loginuserid
            })
              this.isLoading = true;
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'merchantMaster',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listClientData = result.data.rows
                    this.isLoading = false;
                    let totalRows = result.data.count
                    this.resultCount=result.data.count
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },
        // save form fields in mysql database
        saveMerchant() {
            var userdetailEncrypt = window.localStorage.getItem('userdetail')
            var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            var userdetail = JSON.parse(plaintext);

            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            var usertype = '';
            var roleid;

            if (this.localclientid==1001) {
              usertype = 'Merchant';
              roleid = 29;
            }else if (this.localclientid==1002) {
              usertype = 'Supplier';
              roleid = 29;
            }

            if (this.addmerchant.merchantname == undefined || this.addmerchant.businesstype == undefined || this.addmerchant.merchantname == undefined || this.addmerchant.merchantaddress == undefined || this.addmerchant.merchantaddress2 == undefined || this.addmerchant.merchantcity == undefined || this.addmerchant.merchantstate == undefined || this.addmerchant.merchantcountry == undefined || this.addmerchant.merchantpanid == undefined || this.addmerchant.merchantgstnum == undefined || this.addmerchant.merchantpersonname == undefined || this.addmerchant.merchantpersonemail == undefined || this.addmerchant.merchantpersonphone == undefined || this.addmerchant.merchantpersonmobile == undefined || this.addmerchant.merchantloginemail == undefined || this.addmerchant.merchantpassword == undefined ) {
                return false;
            } else {
                this.input = ({
                    merchantname: this.addmerchant.merchantname,
                    businesstype: this.addmerchant.businesstype,
                    merchantname: this.addmerchant.merchantname,
                    merchantpassword: this.addmerchant.merchantname,
                    merchantaddress: this.addmerchant.merchantaddress,
                    merchantaddress2: this.addmerchant.merchantaddress2,
                    city: this.addmerchant.merchantcity,
                    state: this.addmerchant.merchantstate,
                    country: this.addmerchant.merchantcountry,
                    merchantpanid: this.addmerchant.merchantpanid,
                    merchantgstnum: this.addmerchant.merchantgstnum,
                    merchantregisternum: this.addmerchant.merchantregisternum,
                    merchantpersonname: this.addmerchant.merchantpersonname,
                    merchantpersonemail: this.addmerchant.merchantpersonemail,
                    merchantpersonphone: this.addmerchant.merchantpersonphone,
                    merchantpersonmobile: this.addmerchant.merchantpersonmobile,
                    clientid: userdetail.clientid,
                    pincode: this.addmerchant.merchantpincode,
                    merchantloginemail: this.addmerchant.merchantloginemail,
                    merchantpassword: this.addmerchant.merchantpassword,
                    roleid: roleid,
                    warehouseid: this.localwarehouseid,
                    druglicenseno: this.addmerchant.druglicenseno,
                    foodlicenseno: this.addmerchant.foodlicenseno,
                    druglicensenodate: this.addmerchant.druglicensenodate,
                    usertype: usertype
                })

                axios({
                        method: 'POST',
                        'url': apiUrl.api_url + 'SubmitMerchantData',
                        'data': this.input,
                        headers: {
                            'Authorization': 'Bearer ' + myStr
                        }
                    })
                    .then((response) => {
                        if (response.data.msg == 1) {
                            this.$alertify.success(usertype+" Created Successfully")
                            this.addmerchantmodal = false
                            this.getMerchantData();
                        } else {
                            (response.data.msg == 2)
                            this.$alertify.error(usertype+" already existed")
                        }
                    })
                    .catch((httpException) => {
                        console.error('exception is:::::::::', httpException)
                    })
            }
        },
        //to get target id in edit action
        getMerchantRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.getCityList();
            this.merchantaction = 'edit';
            this.addmerchantmodal = true;
            this.addmerchant = data;
            this.merchantid = data.merchantid;
            this.addmerchant.merchantpincode = data.pincode;
            this.addmerchant.merchantcountry = data.country;
            this.loginuserid = data.loginuserid;
            this.addmerchant.merchantstate = data.state;
            this.addmerchant.merchantcity = data.city;
            this.addmerchant.druglicenseno = data.druglicenseno;
            this.addmerchant.foodlicenseno = data.foodlicenseno;
            this.addmerchant.druglicensenodate = data.druglicensenodate;
        },
        //update form fields
        editMerchant() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                merchantid: this.merchantid,
                merchantname: this.addmerchant.merchantname,
                businesstype: this.addmerchant.businesstype,
                merchantname: this.addmerchant.merchantname,
                merchantaddress: this.addmerchant.merchantaddress,
                merchantaddress2: this.addmerchant.merchantaddress2,
                city: this.addmerchant.merchantcity,
                state: this.addmerchant.merchantstate,
                country: this.addmerchant.merchantcountry,
                merchantpanid: this.addmerchant.merchantpanid,
                merchantgstnum: this.addmerchant.merchantgstnum,
                merchantregisternum: this.addmerchant.merchantregisternum,
                merchantpersonname: this.addmerchant.merchantpersonname,
                merchantpersonemail: this.addmerchant.merchantpersonemail,
                merchantpersonphone: this.addmerchant.merchantpersonphone,
                merchantpersonmobile: this.addmerchant.merchantpersonmobile,
                loginuserid: this.loginuserid,
                pincode: this.addmerchant.merchantpincode,
                warehouseid: this.localwarehouseid,
                druglicenseno: this.addmerchant.druglicenseno,
                foodlicenseno: this.addmerchant.foodlicenseno,
                druglicensenodate: this.addmerchant.druglicensenodate
            })
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateMerchant',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.msg > 0) {
                        this.$alertify.success("Merchant Record Updtaed Successfully");
                        this.addmerchantmodal = false;
                        this.getMerchantData();
                    }
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },
        //to get target id in active/inactive modal
        getStatusRowData(data) {
            this.Statusaction = 'add'
            this.modalShow = true
            this.merchantid = data.merchantid
            this.status = data.mstatus

            if (data.mstatus.trim() == 'Active') {
                this.changestatus = 'De-Activate'
            } else {
                this.changestatus = 'Activate'
            }
            console.log(this.changestatus);
        },
        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getMerchantData()
        },
        //validate all form fields on onsubmit()
        onSubmit: function(event) {
            this.$validator.validateAll().then(() => {
                event.target.reset();
                console.log('form is valid', this.model)
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/merchant/merchant.component.js